@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

$var-shadow: 0 2px 2px 0 Colors.$col-shadow;
$var-borderRadius: 2px;
$var-imageHeight: 40px;
$var-imageMaxWidth: 200px;

.virtual-row-container {
	display: flex;
	flex-direction: column;
	margin-bottom: Constants.$val-spacing-s;
	box-shadow: $var-shadow;
	background-color: white;
}

.virtual-row-header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.virtual-row-header-links {
	display: flex;
	flex-direction: row;
}

.virtual-row-header-link {
	margin-right: Constants.$val-spacing-m;
	color: Colors.$col-blue;
	margin-top: Constants.$val-spacing-m;
	cursor: pointer;
}

.virtual-row-header-name {
	font-weight: bold;
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeXBig;
	padding-top: Constants.$val-spacing-xl;
	padding-left: Constants.$val-spacing-m;
}

.virtual-row-content-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.virtual-row-signatures-container {
	display: flex;
	flex-direction: column;
	background-color: Colors.$col-greyLight;
	padding: Constants.$val-spacing-m;
	margin-left: Constants.$val-spacing-m;
	flex: 2;
}

.virtual-row-signatures-header {
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeRegular;
}

.original-time-container {
	display: flex;
	flex-direction: column;
	background-color: Colors.$col-greyLight;
	padding: Constants.$val-spacing-s;
	margin-left: Constants.$val-spacing-m;
	flex: 3;
}

.original-time-header {
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeRegular;
	color: white;
	background-color: Colors.$col-design-blue8;
	padding: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
}

.time-card-container {
	display: flex;
	flex-direction: column;
	background-color: Colors.$col-greyLight;
	padding: Constants.$val-spacing-s;
	margin-left: Constants.$val-spacing-m;
	margin-right: Constants.$val-spacing-m;
	flex: 3;
}

.time-card-header {
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeRegular;
	color: Colors.$col-design-gray6;
}

.time-sheet-signature-status-label{
	color: Colors.$col-greyDark;
	font-size: Constants.$val-fontSizeSmall;
	font-weight: normal;
	display: flex;
	flex-direction: row;
}

.image {
	margin-top: Constants.$val-spacing-s;
	height: $var-imageHeight;
	max-width: $var-imageMaxWidth;
	background-color: white;
	margin-right: Constants.$val-spacing-s;
	border-left: 1px solid Colors.$col-greyMid;
	border-right: 1px solid Colors.$col-greyMid;
}

.signature-name {
	margin-left: Constants.$val-spacing-xs;
}

.signature-superintendent {
	color: Colors.$col-red;
	margin: Constants.$val-spacing-s 0;
}

.temp-labor-icon {
	margin-right: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeXXBig;
}